import React from 'react';

import FeatureWrapper from './ListViewWrapper/FeatureWrapper';
import AoLovesWrapper from './ListViewWrapper/AoLovesWrapper';
import Wrapper from './ListViewWrapper/Wrapper';

const ProductCardListView = ({ index, product }) => {
	const showFeaturedProduct = index === 0 && product.IsFeaturedProduct;

	return showFeaturedProduct ? (
		<FeatureWrapper {...{ product, index }} />
	) : (
		<Wrapper {...{ product, index }} />
	);
};

export default ProductCardListView;
